import PropTypes from 'prop-types';
import React from 'react';

import { flagLinkPropTypes } from '../../utils';
import FlagLink from './FlagLink';
import styles from './FlagLink.module.scss';

const FlagLinkColumn = ({ data }) => {
	const renderFlagLink = (item, index) => <FlagLink key={index} {...item} />;

	return <ul className={styles.flagLinkColumn}>{data.map(renderFlagLink)}</ul>;
};

FlagLinkColumn.propTypes = {
	data: PropTypes.arrayOf(flagLinkPropTypes),
};

export default FlagLinkColumn;
